import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '木瓜影视-电视剧大全：高清电视剧全集免费在线观看不卡顿',
    description: '木瓜影视提供高清电视剧全集免费在线观看，最新热播剧不缓冲无广告极速播放，海量电视剧资源每日更新，满足追剧需求。',
    url: 'https://huarukai.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '木瓜影视',
      url: 'https://huarukai.cn/',
    },
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <main>
        <HeroBanner />
        <CategoryNav />
        <HotSection />
        <StatsSection />
        <LatestSection />
        <FAQSection />
      </main>
    </>
  );
}